export const saveDistributorList = (list) => {
  return {
    type: 'SET_DISTRIBUTOR_LIST',
    payload: list
  }
};

